export default "__VITE_ASSET__DfJzC8Gw__"